import { type FC, useContext } from "react";
import { DragDropComponent } from "./DragDropComponent";
import { DragDropContainerEmpty } from "./DragDropContainerEmpty";
import { DragDropContainerWrapper } from "./DragDropContainerWrapper";
import { useDragDropContainer } from "./DragDropManager";
import { DragDropEditorContext } from "./DragDropTypes";

interface Props {
    id: string;
}

export const DragDropContainer: FC<Props> = ({ id }) => {
    const { selected } = useContext(DragDropEditorContext);

    const container = useDragDropContainer(id);

    if(!container.length) {
        return (
            <DragDropContainerEmpty
                id={id}
            />
        );
    }

    return (
        <DragDropContainerWrapper
            id={id}
            count={container.length}
        >
            {container.map((componentId, index) => (
                <DragDropComponent
                    key={componentId}
                    id={componentId}
                    index={index}
                    selected={selected}
                    container={id}
                />
            ))}
        </DragDropContainerWrapper>
    );
};
